import React from 'react';
export const Logo = ({
  isSmall = false
}) => {
  const svgSize = isSmall ? 60 : 120;
  const textClass = isSmall ? 'text-xl font-serif tracking-wider text-slate-800' : 'text-3xl font-serif tracking-wider text-slate-800';
  const subtitleClass = isSmall ? 'text-sm tracking-widest text-slate-700 mt-0.5' : 'text-xl tracking-widest text-slate-700 mt-1';
  return <div className={`flex ${isSmall ? 'flex-row items-center gap-3' : 'flex-col items-center'}`} data-id="element-128" data-mp="msuos2321tc8">
      {/* Logo Symbol */}
      <div className={isSmall ? '' : 'relative mb-4'} data-id="element-129" data-mp="rqw88o4e7uo8">
        <svg width={svgSize} height={svgSize} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="logoTitle" role="img" data-id="element-130" data-mp="ds6cbbtb811g">
          <title id="logoTitle" data-id="element-131" data-mp="2yi5f76vhzjx7">Aurum Grove Capital Logo</title>
          {/* Outer circle */}
          <circle cx="60" cy="60" r="58" stroke="#D4AF37" strokeWidth="4" fill="transparent" data-id="element-132" data-mp="32k8u65hdl6n8" />
          {/* Inner circle */}
          <circle cx="60" cy="60" r="48" stroke="#D4AF37" strokeWidth="2" fill="transparent" data-id="element-133" data-mp="19wyid82nfvkn" />
          {/* Stylized tree/growth symbol */}
          <path d="M60 20 L60 85" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" data-id="element-134" data-mp="1jsjfarsv25nj" />
          <path d="M60 40 L45 55" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" data-id="element-135" data-mp="1sv2cowdvnq2e" />
          <path d="M60 50 L45 65" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" data-id="element-136" data-mp="27j5myhyydnx0" />
          <path d="M60 60 L45 75" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" data-id="element-137" data-mp="2gk3qz09e5vfl" />
          <path d="M60 40 L75 55" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" data-id="element-138" data-mp="2bmv9z2zzbxfx" />
          <path d="M60 50 L75 65" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" data-id="element-139" data-mp="1e6pecd1fxp35" />
          <path d="M60 60 L75 75" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" data-id="element-140" data-mp="1i6zm9v8smpkn" />
          {/* Stylized base/foundation */}
          <path d="M40 85 C40 85, 60 75, 80 85" stroke="#D4AF37" strokeWidth="3" fill="transparent" strokeLinecap="round" data-id="element-141" data-mp="1rxkixd4wpk0x" />
        </svg>
      </div>
      {/* Company Name */}
      <div className="text-center" data-id="element-142" data-mp="25y4xty7pavp5">
        <h1 className={textClass} data-id="element-143" data-mp="25x3mrtqoq97f">
          <span className="text-[#D4AF37]" data-id="element-144" data-mp="25xbyhib2n8h1">AURUM</span> GROVE
        </h1>
        <p className={subtitleClass} data-id="element-145" data-mp="7jtvq8fqtwdw">CAPITAL</p>
      </div>
    </div>;
};